<template>
  <div class="quote" :class="color">
    <blockquote>
      <p>{{quote}}</p>
    </blockquote>
    <div class="image-box" v-if="image">
      <img :src="imgPath" :alt="authorName + ', ' + authorRole">
    </div>
    <p class="author">
      <strong class="name">{{authorName}}</strong>
      <span class="role" v-html="authorRole"></span>
    </p>
  </div>
</template>

<script>
export default {
  name: "Quote",
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    quote: String,
    authorName: String,
    authorRole: String,
    image: String
  },
  data() {
    return {
      imgPath: require('../assets/images/' + this.image),
    }
  }
}
</script>

<style scoped>
  .quote {
    margin: calc(20px + 5%) auto;
    max-width: 720px;
    text-align: center;
    color: #102D61;
  }
  .pink p {
    color: #C7125C;
  }
  .yellow p {
    color: #FCC500;
  }
  .gradient blockquote p, .gradient .author * {
    background: linear-gradient(70deg, #B1D995 0%, #3CB2B8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .yellow p.author {
    color: #102D61;
  }
  .author {
    display: inline-block;
    line-height: 1.4;
  }
  blockquote {
    font-size: 36px;
    font-weight: 700;
    line-height: 1.2;
    padding: 0;
    margin: 0 0 30px;
  }
  p {
    margin: 10px 0 !important;
    line-height: 1.3;
  }
  .quote blockquote + .image-box {
    position: relative;
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 auto 10px;
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  strong, span {
    display: block;
  }
  @media(max-width: 767px) {
    blockquote {
      font-size: 24px;
    }
  }
</style>